import { MessageDescriptor, defineMessage } from 'react-intl';

/**
 * Knock workflow category ids used for preferences UI grouping.
 * Keep in sync with mi-api Knock workflow.json category fields.
 * UI-only — preference persistence stays per workflow key, not under Knock categories.
 */
export const NOTIFICATION_WORKFLOW_CATEGORIES = ['audit', 'social-upload', 'fragments'] as const;

export type NotificationWorkflowCategory = (typeof NOTIFICATION_WORKFLOW_CATEGORIES)[number];

/**
 * Display order for category sections on the preferences page.
 */
export const NOTIFICATION_WORKFLOW_CATEGORY_ORDER: readonly NotificationWorkflowCategory[] =
  NOTIFICATION_WORKFLOW_CATEGORIES;

/**
 * Type guard: true when `value` is a known notification workflow category.
 */
export function isNotificationWorkflowCategory(
  value: string,
): value is NotificationWorkflowCategory {
  return (NOTIFICATION_WORKFLOW_CATEGORIES as readonly string[]).includes(value);
}

/** Section labels for the preferences form (grouped by Knock category). */
export const notificationWorkflowCategoryMessages: Record<
  NotificationWorkflowCategory,
  MessageDescriptor
> = {
  audit: defineMessage({
    id: 'notifications.preferences.category.audit',
    defaultMessage: 'Auditoría',
  }),
  'social-upload': defineMessage({
    id: 'notifications.preferences.category.socialUpload',
    defaultMessage: 'Redes',
  }),
  fragments: defineMessage({
    id: 'notifications.preferences.category.fragments',
    defaultMessage: 'Fragmentos',
  }),
};
